
import { Domain } from "../models/domain.model";


export const domainReducer = (state: Domain, action: { type: string; value: Domain; }) => {
    switch (action.type) {
        case 'set':
            return action.value;
        default: throw new Error('Unexpected action');
    }
};